/// <summary>
/// This object provides js functions for the widget ComparisonList <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 16.5.2025<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 16.5.2025                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
jQuery.widget("bluaul.FullComparisonList", $.bluaul.vcMenuTemplate, {
 
   
    _create: function () {
        var me = this;
        try {

          
            me.element.html("");
            me.options.invoke.vcvid = 392;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            me._super();
          
        } catch (e) { me.writeError('_create', e); return false;}
        return true;
    },





    _initVariables: function () {
        var me = this;
        try {
            me._super();
            me.settings.defaultChart = "comparisonlist";
            me.settings.menu.top.showMenuAsDropdown = false;
            me.settings.menu.top.interval.intervals = [1];
            me.settings.menu.top.interval.default = 3; //we start with months
            me.settings.toggleView = true;
            me.settings.showSignalsInContent = true;
            me.settings.signalSelection = true;
            me.settings.showAllSignalsAtStart = false;
            me.settings.enableFilterForInvalidSignals = true;
            me.settings.hideSignalsWithNotAllowedSettings = false;
            me.settings.showArchiveRules = false;
            me.settings.enableMeta = false;

            me.settings.menu.top.showHeaders = true;
            me.settings.menu.top.interval.enabled = false;
            me.settings.menu.top.datatype.enabled = false;
            me.settings.menu.top.charts.enabled = false;
            me.settings.menu.top.opt.enabled = false;
            me.settings.menu.top.opt.showInterventions = false;
            me.settings.menu.top.opt.showTickets = false;

            me.settings.menu.main.button.enabled = true;
            me.settings.menu.main.button.showTakeBtnOnly = false;
            me.settings.menu.main.date.enabled = true;
            me.settings.menu.main.date.showTimespan = false;
            me.settings.menu.main.dateComparison.enabled = false;
            me.settings.menu.main.rampResolution.enabled = false;
            me.settings.menu.main.rampOptions.enabled = false;
            me.settings.menu.main.rampTempCharts.enabled = false;
            me.settings.menu.main.specificOptions.enabled = true;
            me.settings.menu.main.history.enabled = false;

            me.settings.menu.top.opt.showTags = false;
            me.settings.menu.top.opt.showRules = false;
            me.settings.menu.top.export.enabled = true;
            me.settings.menu.top.export.showFavorites = false;
            me.settings.menu.top.export.showShare = false;
            me.settings.selection.choice.enabled = true;
            me.settings.selection.entries.button.enabled = false;
            me.settings.selection.entries.signals.showIcons = false;

            me.settings.subvisual.content.signalSelection = false;


            me.settings.comparisonList = {
                minYears: 2,
                maxYears: 5,
                defaultYears: 3,
                minDays: 14,
                maxDays: 45,
                defaultDays: 21
            }

        } catch (e) {
            me.writeError('_initVariables', e);
            return false;
        }
        return true;
    },




    _addAdditionalChartsToSettings: function () {
        var me = this;
        try {

            me._super();

            $.each(me.settings.charts, function () { this.enabled = false });
            me.settings.charts.filter(function (item) { return item.id == "comparisonlist" })[0].enabled = true;
            $.each(me.settings.iconCharts, function () { this.enabled = false });

        } catch (e) {
            me.writeError('_addAdditionalChartsToSettings', e);
            return false;
        }
        return true;
    },


    _fillSubvisualStructure: function () {
        /// <summary>
        /// we build up the structure 
        /// </summary>
        var me = this;
        try {
            let obj = null;


            obj = me.vcMenu.menu.main.specificOptions;

            obj.removeClass("vc-grid-2col").addClass("vc-grid-6col");


            var ddlYears = $("<select>").attr("id", "specific-option-settings-years").addClass("ddl").css("width", "100%");
            for (var i = me.settings.comparisonList.minYears; i <= me.settings.comparisonList.maxYears; i++) {
                ddlYears.append($("<option>").val(i).text(i + " " + me.specific.resources.years));
            }
            ddlYears.val(me.settings.comparisonList.defaultYears);
            var divYears = $("<div>").attr("id", "div-years").addClass("vc-grid-margin-right").css("float", "left"); 
           

            divYears.vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.years, clickable: true, isList: true, content: ddlYears }]
            });
            obj.append(divYears);


            var ddlType = $("<select>").attr("id", "specific-option-settings-type").addClass("ddl").css("width", "100%");
            ddlType.append($("<option>").val("SINGLE").text(me.specific.resources.singleView));
            ddlType.append($("<option>").val("MULTI").text(me.specific.resources.separateView));


            ddlType.val("MULTI"); // TODO MKU: currently set to single here (not in aspx file, because otherwise export works not correctly)
            var divType = $("<div>").attr("id", "div-type").addClass("vc-grid-margin-right").css("float", "left");

            divType.vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.currentView, clickable: true, isList: true, content: ddlType }]
            });
            obj.append(divType);

        } catch (e) { me._writeErr(e); }
    },



    _loadSubvisualContent: function (status) {
        var me = this;
        try {

            if (!me.error) {
                me._initSubvisualContent(status);


                var param = {
                    Bsaids: status.signals.allSelectedBsaids,
                    StartDate: status.menu.startDate,
                    EndDate: status.menu.endDate,
                    Years: parseInt(me.vcMenu.menu.main.specificOptions.find("#specific-option-settings-years").val()),
                    Type: me.vcMenu.menu.main.specificOptions.find("#specific-option-settings-type").val()
                    //Days: parseInt(me.vcMenu.menu.main.specificOptions.find("#specific-option-settings-days").val())
                };

                //send the config for the share url
                //status.signals.shareParameter = {
                //    'info': { bsaid: status.subvisual.selectedBsaid, name: '', description: '', startDate: status.menu.startDate, endDate: status.menu.endDate, dateUserDef: status.date.isSingle == false, interval: status.menu.interval },
                //    'visualname': "HEATMAP", "vcvid": 303, 'parameter': JSON.stringify(param), 'signalparameter': ""
                //};
              
                me.vcMenu.subvisual.content.ComparisonList({ invokeType: "addVisualBase", blid: me.specific.LoggerId, parameter: param, deviceType: me.settings.deviceType });

            }

        } catch (e) { me._writeErr(e); }


    },

});

